<template>
  <div class="registerform__step step__success">
    <div class="step__content">
      <div class="step__headline">
        <h4 class="-color-alpha">Etwas ist schiefgelaufen</h4>
        <p v-if="errorMessage">{{ errorMessage[0] }}</p>
        <p v-else>Leider konnte Ihre Anfrage nicht erfolgreich abgeschickt werden.</p>
        <div class="form__action">
          <div class="-btn-alpha" @click="$emit('updateStep', 'Form')"><span>Zurück</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Error',
  props: ['registerform', 'privacyPage', 'errorMessage']
}
</script>
